// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"60":"3fe984c8","835":"ef33a262","883":"55996070"}[chunkId] + ".js";
};